module.exports = __webpack_public_path__ + "static/media/dogPrompt.bc8ee841.png";